module.exports = __webpack_public_path__ + "img/500.96a273c.svg";